
import { ClaimQueryStateActions } from "../dashboard/types";
import allClaims from "../copayClaimsHCP/allClaims";
import completedClaims from "../copayClaimsHCP/completedClaims";
import { ClaimQueryParamsState, CopayCasesTabConfig } from "../copayClaimsHCP/types";



export const CopayClaimsTabsConfig: CopayCasesTabConfig[] = [
  {
    key: "all_enrollment",
    label: "All Enrollments",
    Component: allClaims,
    dataSelector: (d:any) => d.all_enrollment,
    pageKey: "page" as keyof ClaimQueryParamsState, // ✅ keyof PatientFilterState
    changeAction: ClaimQueryStateActions.CHANGE_PAGE,
  },
  {
    key: "completed_claims",
    label: "Completed Claims",
    Component: completedClaims,
    dataSelector: (d:any) => d.completed_claims,
    pageKey: "page" as keyof ClaimQueryParamsState, // ✅ keyof PatientFilterState
    changeAction: ClaimQueryStateActions.CHANGE_PAGE,
  },
];
